<template>
  <div class="wrapper">
    <img class="cover" src="@/assets/logo.png" alt="" />
    <span class="title hidden md:flex" :style="{ color: color || 'black' }">MuleEx</span>
  </div>
</template>

<script>
export default {
  props: ["color"]
};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 5px;
}

.cover {
  height: 30px;
  display: block;
}

.title {
  font-weight: 600;
  font-size: 28px;
}
</style>
